import { render, staticRenderFns } from "./TextBlob.vue?vue&type=template&id=7350c9d4&scoped=true"
import script from "./TextBlob.vue?vue&type=script&lang=js"
export * from "./TextBlob.vue?vue&type=script&lang=js"
import style0 from "./TextBlob.vue?vue&type=style&index=0&id=7350c9d4&prod&scoped=true&lang=css"
import style1 from "./TextBlob.vue?vue&type=style&index=1&id=7350c9d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350c9d4",
  null
  
)

export default component.exports